import { useMutation } from 'react-query';
import { message } from 'antd';
import request from '../../../../helpers/request';
import { modalContentTypes } from '../config/modalContent';
import { getUpdatedRequest } from './getUpdatedRequest';
import { setPaymentTypes } from './paymentTypesMutation';
import { useMemo } from 'react';

// price = { sum: number, isFinal: boolean }
const setPrice = ({ requestId, price }) =>
  request.post(
    `/Request/set_price/${requestId}`,
    price,
    `Не удалось выставить счет`,
    'Error'
  );

// data = { paymentStateId: number }
const setPaymentState = async ({ requestId, data }) => {
  return request.put(
    `/Request/set_payment_state/${requestId}`,
    data,
    `Не удалось установить выбранный статус оплаты`,
    'Error'
  );
};

const successHandler = async (requestId, cb) => {
  if (typeof cb === 'function') {
    const updatedRequest = await getUpdatedRequest(requestId);
    cb(updatedRequest);
  }
};

const onSetPriceSuccess = async (res, { requestId, paymentTypesData }, cb) => {
  if (res !== 'Error') {
    if (paymentTypesData) {
      const res = await setPaymentTypes({ requestId, data: paymentTypesData });

      if (res !== 'Error' && !res.success) {
        message.error(res.message || 'Не удалось установить способы оплаты');
      }
    }

    await successHandler(requestId, cb);
  }
};

const onSetStateSuccess = async (res, { requestId }, cb) => {
  if (res !== 'Error') {
    if (!res.success) {
      message.error(res.message || 'Не удалось установить статус оплаты');
      return;
    }

    await successHandler(requestId, cb);
  }
};

const submitMutationOptions = {
  [modalContentTypes.invoiceAndTypes]: {
    fn: setPrice,
    onSuccess: onSetPriceSuccess,
  },
  [modalContentTypes.typesAndState]: {
    fn: setPaymentState,
    onSuccess: onSetStateSuccess,
  },
};

export const useSumbit = ({ contentType, cbRef }) => {
  const { fn, onSuccess } = useMemo(
    () =>
      submitMutationOptions[contentType] || {
        fn: () => {},
        onSuccess: () => {},
      },
    [contentType]
  );

  const mutation = useMutation(fn, {
    onSuccess: (res, data) => onSuccess(res, data, cbRef.current),
  });

  return {
    submit: mutation.mutate,
    submitAsync: mutation.mutateAsync,
    loading: mutation.isLoading,
  };
};
